export const getEmptyFieldValue = ({ filterValue }: { filterValue?: string | null }) => '';

export const getFilterFieldValue = ({ filterValue }: { filterValue?: string | null }) =>
  filterValue ? filterValue : '';
